import classNames from "classnames";
import { ReactNode, HTMLAttributes } from "react";

export interface ListProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  variant?: "plain" | "glass" | "card" | "divided";
  className?: string;
}

export const List = ({
  children,
  variant = "plain",
  className,
  ...props
}: ListProps) => {
  return (
    <div
      className={classNames(
        "flex flex-col font-sans",
        variant === "divided" && "divide-y divide-primary-200/50 dark:divide-primary-800/40",
        variant === "glass" && "rounded-2xl border border-white/20 dark:border-primary-800/30 bg-white/20 dark:bg-content-900/25 backdrop-blur-xl shadow-[0_8px_30px_-12px_rgba(15,23,42,0.15)] overflow-hidden divide-y divide-white/20 dark:divide-primary-800/30",
        variant === "card" && "rounded-xl border border-primary-100 bg-white/50 dark:border-primary-800/60 dark:bg-content-900/40 backdrop-blur-md overflow-hidden divide-y divide-primary-200/60 dark:divide-primary-800/50",
        variant === "plain" && "gap-2",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
